/**
 * 文本润色服务
 */

import { apiClient } from './api';

export const textService = {
  /**
   * 润色prompt
   * @param prompt - 原始文本
   * @param type - 类型：image 或 video
   */
  polishPrompt: (prompt: string, type: 'image' | 'video') => {
    return apiClient.post('/text/polish', { prompt, type });
  },

  /**
   * 获取润色配置
   */
  getPolishConfig: () => {
    return apiClient.get('/text/polish-config');
  }
};

